/**
 * Where to put a station on screen once its detail panel is open.
 *
 * The panel covers part of the map, so centring on the map container puts the
 * station underneath it. The correction depends on which way the panel sits:
 *
 *   desktop  a column down the right — shift the centre left
 *   mobile   a sheet across the bottom — shift the centre up
 *
 * Shifting left on mobile, where the "panel" is the full width of the screen,
 * moved the station half a screen sideways and off the left edge.
 */
export interface PanelLayout {
  panelWidth: number;
  panelHeight: number;
  mapWidth: number;
  mapHeight: number;
  viewportHeight: number;
}

/** MapLibre `offset`: pixels to move the target away from the container centre. */
export function detailOffset(l: PanelLayout): [number, number] {
  // A panel as wide as the map is a bottom sheet, not a side column.
  const isSheet = l.panelWidth >= l.mapWidth - 1;

  if (!isSheet) return [-l.panelWidth / 2, 0];

  // The sheet is pinned to the bottom of the viewport, so the strip of map still
  // in view runs from the top of the map down to the top of the sheet.
  const sheetTop = Math.max(0, l.viewportHeight - l.panelHeight);
  const visible = Math.min(l.mapHeight, sheetTop);

  // Centre within that strip rather than within the whole container.
  return [0, (visible - l.mapHeight) / 2];
}
